/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface KeywordField
 */
export interface KeywordField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof KeywordField
     */
    value: string;
}

/**
 * Check if a given object implements the KeywordField interface.
 */
export function instanceOfKeywordField(value: object): value is KeywordField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function KeywordFieldFromJSON(json: any): KeywordField {
    return KeywordFieldFromJSONTyped(json, false);
}

export function KeywordFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): KeywordField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function KeywordFieldToJSON(value?: KeywordField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

